import * as React from 'react';
import { observer } from 'mobx-react';
import * as classnames from 'classnames';

export enum iconSetNames {
    wide = 'wide',
    wideColor = 'wideColor',
    narrow = 'narrow'
}

type IIconSetName = keyof typeof iconSetNames;
type ISvg = React.SVGProps<SVGSVGElement>;
type IIconSvgIcon = React.FunctionComponent<ISvg>;

export interface IIconSetMap {
    [iconName: string]: {
        [iconSetName in IIconSetName]?: IIconSvgIcon | null;
    };
}
export interface IBaseIconSet {
    name: string;
    className?: string;
    iconSetName?: IIconSetName;
    [svgprop: string]: ISvg | unknown;
}

interface IIconSet extends IBaseIconSet {
    iconSetMap: IIconSetMap;
}

const genericSvgIconClassname = 'elc-icon-svg js-icon-svg';
const DEFAULT_ICON_SET_NAME = iconSetNames.wide;

const isValidIcon = (iconSetName: IIconSetName, name: string) =>
    name && Object.values(iconSetNames).includes(iconSetNames[iconSetName]);

const IconSet = observer(
    ({ className = '', iconSetMap, iconSetName, name = '', ...svgProps }: IIconSet) => {
        const iconSet = iconSetName ? iconSetName : DEFAULT_ICON_SET_NAME;
        const IconSvg = iconSetMap?.[name]?.[iconSet];

        if (!isValidIcon(iconSet, name) || !IconSvg) {
            return null;
        }

        const iconClassName = classnames(`elc-${name}-icon`, className, genericSvgIconClassname);

        return <IconSvg className={iconClassName} focusable="false" {...svgProps} />;
    }
);

export { IconSet };
